// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"ff6686dbf386174a4c2331729d7c1028ef9d8a2c"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "14.2.35";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/apps/docs/production";globalThis["_sentryAssetPrefix"] = "https://frontend-apps-multi-region.workos.com/apps/docs/production";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from '@sentry/nextjs';
import {
  createTracesSampler,
  sentryBeforeSend,
  sentryIgnoreErrors,
} from '@workos-inc/sentry-client-config';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tracesSampler: createTracesSampler(0.001),
  // Enable logs to be sent to Sentry
  enableLogs: false,
  release: process.env.NEXT_PUBLIC_COMMIT_SHA,
  environment: process.env.NEXT_PUBLIC_NODE_ENV,
  normalizeDepth: 10,
  beforeSend: sentryBeforeSend,
  ignoreErrors: sentryIgnoreErrors,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
